import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import './i18n/config'
import { env } from './config/env'
// Importer HelmetProvider pour react-helmet-async
import { HelmetProvider } from 'react-helmet-async'

// Importer les outils de surveillance des traductions
import { initTranslationMonitor } from './i18n/translation-monitor'
import { initTranslationChecker } from './i18n/translation-checker'

// Note: reloadTranslations supprimé car les traductions sont maintenant importées directement

// Auto-récupération transparente lors du déploiement d'une nouvelle version (chunks obsolètes)
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Nouvelle version détectée ou échec de chargement de module, rechargement...', event);
  const lastReload = sessionStorage.getItem('vite_preload_retry');
  const now = Date.now();
  if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
    sessionStorage.setItem('vite_preload_retry', now.toString());
    window.location.reload();
  }
});

window.addEventListener('error', (event) => {
  const errorMsg = event.message || '';
  if (
    errorMsg.includes('dynamically imported module') ||
    errorMsg.includes('Failed to load module script') ||
    errorMsg.includes('MIME type of "text/html"')
  ) {
    console.warn('Chunk obsolète détecté, actualisation automatique...', errorMsg);
    const lastReload = sessionStorage.getItem('vite_chunk_retry');
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('vite_chunk_retry', now.toString());
      window.location.reload();
    }
  }
});

// Initialiser les outils de surveillance des traductions en développement
if (env.DEV) {
  // Initialiser le moniteur de traduction en temps réel
  initTranslationMonitor();

  // Initialiser le vérificateur de traductions au démarrage
  initTranslationChecker();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
)
